import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsOverviewService } from '../../admissions-overview.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'admissions-overview-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './overview-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./overview-view.part.scss'],
})
export class AdmissionsOverviewViewPart {

	private readonly util = inject(UtilityService);
	private readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly pageService = inject(AdmissionsOverviewService);

	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});
}